// src/api/attachAxiosStore.js
import { axiosInstance } from "./apiConfig";
import { addToast } from "../redux/slices/toastSlice";
import { clearUser } from "../redux/slices/createUserSlice";

export function attachAxiosStore(store) {
  axiosInstance.interceptors.response.use(
    (res) => res,
    (error) => {
      console.log("error inside interceptor", error);
      const data = error?.response?.data;
      const code = error?.response?.data?.errorCode;
      const status = error?.response?.status;

      if (
        code === "INVALID_SESSION" ||
        code === "SESSION_EXPIRED" ||
        code === "DEVICE_MISMATCH" ||
        status === 401
      ) {
        try {
          store.dispatch(
            addToast({
              message: "Session expired. Please sign in again.",
              isSuccess: false,
            }),
          );
          store.dispatch(clearUser());
        } catch {}
        setTimeout(() => {
          window.location.replace("/login");
        }, 2000);
      }

      if (data?.errorCode === "EXIT_LOCKED") {
        try {
          store.dispatch(
            addToast({
              message:
                data?.message ||
                "You’ve handed in your investigator code — returning to debrief.",
              isSuccess: false,
            }),
          );
        } catch {}
        setTimeout(() => {
          window.location.replace("/gameFinishP2");
        }, 2000);
      }

      return Promise.reject(error);
    },
  );
}
